import { render, staticRenderFns } from "./BxButton.vue?vue&type=template&id=566c639b&"
import script from "./BxButton.vue?vue&type=script&lang=js&"
export * from "./BxButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports